import { z } from 'zod';
export const MAX_RENT_COMPS = 12;
export const rentCompSchema = z.object({
    address: z.string().min(1),
    bedrooms: z.number().min(0),
    bathrooms: z.number().min(0),
    squareFootage: z.number().positive().optional(),
    rent: z.number().positive(),
    url: z.string().min(1),
});
function normalizeHttpsUrl(raw) {
    let url;
    try {
        url = new URL(raw);
    }
    catch {
        return undefined;
    }
    if (url.protocol !== 'https:')
        return undefined;
    if (url.username !== '' || url.password !== '')
        return undefined;
    url.hash = '';
    const path = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
    return `${url.protocol}//${url.host}${path}${url.search}`;
}
export function keepCitedComps(comps, sources) {
    return comps
        .flatMap((comp) => {
        const url = citedUrl(comp.url, sources);
        return url === undefined ? [] : [{ ...comp, url }];
    })
        .slice(0, MAX_RENT_COMPS);
}
export function citedUrl(url, sources) {
    const wanted = normalizeHttpsUrl(url);
    if (wanted === undefined)
        return undefined;
    return sources.some((source) => normalizeHttpsUrl(source.url) === wanted) ? wanted : undefined;
}
export function parseRentComps(raw) {
    return raw.flatMap((item) => {
        const parsed = rentCompSchema.safeParse(item);
        return parsed.success ? [parsed.data] : [];
    });
}
//# sourceMappingURL=rentRadarComps.js.map